/* 
FireStore services 
*/
import firestore from '../../../config/firebase';

/**
 * saveResponseData()
 * Save the Editor data to firestore
 * Method : Set
 */
export const saveResponseData = (responseData, docId) => {
    return firestore
        .collection('ReportStatus')
        .doc(docId)
        .set(
            {
                responseData,
            },
            { merge: true },
        );
};

/**
 * getResponseData()
 * Get the Editor data from firestore
 * Method : Get
 */
export const getResponseData = (docId) => {
    return firestore
        .collection('ReportStatus')
        .doc(docId)
        .get();
};

/**
 * generateTabs()
 * Get tabs from firestore to generate editors initially
 * Method : Get
 */
export const generateTabs = (reportType) => {
    return firestore
        .collection('ReportStatusTabConfiguration')
        .where('ReportType', '==', reportType)
        .get();
};

/**
 * Get Total image count to be upload from the localstorage
 */
export const GetTotalImageCount = () => {
    let imageCount = localStorage.getItem('TotalImageCount')
        ? parseInt(localStorage.getItem('TotalImageCount'))
        : {};

    return imageCount;
};
